import React, { useState, useCallback, useEffect } from "react";
import { TextField, Button } from "@material-ui/core";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Handle } from "react-flow-renderer";
import AerosNode, { targetHandleStyle, sourceHandleStyle } from "./AerosNode";
import { nodeSummary } from "../flowRules";
import useAerosModalStyles from "../../../styles/aerosModalStyles";
import { i18n } from "../../../translate/i18n";

const VariableNode = React.memo(({ data, id, selected }) => {
  const m = useAerosModalStyles();
  const [variableName, setVariableName] = useState(data.variableName || "");
  const [variableValue, setVariableValue] = useState(data.variableValue || "");
  const [variableType] = useState(data.variableType || "text");
  const [savedStatus, setSavedStatus] = useState(data.savedStatus || "");
  const [showSavePopup, setShowSavePopup] = useState(false);

  useEffect(() => {
    data.variableName = variableName;
    data.variableValue = variableValue;
    data.variableType = variableType;
    data.savedStatus = savedStatus;
  }, [variableName, variableValue, variableType, savedStatus, data]);

  useEffect(() => {
    let timer;
    if (showSavePopup) {
      timer = setTimeout(() => setShowSavePopup(false), 3000);
    }
    return () => clearTimeout(timer);
  }, [showSavePopup]);

  const handleSave = useCallback(() => {
    if (variableName) {
      window.flowVariables = window.flowVariables || {};
      window.flowVariables[variableName] = variableValue;
      setSavedStatus("Salvo!");
      setShowSavePopup(true);
    }
  }, [variableName, variableValue]);

  return (
    <AerosNode
      id={id}
      type="variable"
      selected={selected}
      width={280}
      hasTarget={false}
      hasSource={false}
      extra={
        <>
          {/* ids "variable-in"/"variable-out" preservados do nó antigo */}
          <Handle type="target" position="left" id="variable-in" style={targetHandleStyle()} />
          <Handle type="source" position="right" id="variable-out" style={sourceHandleStyle()} />
          <div className="nodrag" style={{ padding: "0 12px 12px", display: "flex", flexDirection: "column", gap: 8 }}>
            <div>
              <label className={m.fieldLabel}>{i18n.t("aeros.flow.variable.name")}</label>
              <TextField
                className={`${m.input} ${m.inputSmall}`}
                size="small"
                variant="outlined"
                value={variableName}
                onChange={(e) => setVariableName(e.target.value)}
                fullWidth
              />
            </div>
            <div>
              <label className={m.fieldLabel}>{i18n.t("aeros.flow.variable.value")}</label>
              <TextField
                className={`${m.input} ${m.inputSmall}`}
                size="small"
                variant="outlined"
                value={variableValue}
                onChange={(e) => setVariableValue(e.target.value)}
                fullWidth
                multiline
                minRows={2}
                maxRows={4}
              />
              <div className={m.hint}>{i18n.t("aeros.flow.variable.valueHint")}</div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span className={m.hint} style={{ marginTop: 0, color: showSavePopup ? "#34D399" : undefined }}>
                {showSavePopup ? i18n.t("aeros.flow.variable.savedToast") : savedStatus && i18n.t("aeros.flow.variable.saved")}
              </span>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={handleSave}
                startIcon={<CheckCircleOutlineIcon />}
                style={{ textTransform: "none" }}
              >
                {i18n.t("aeros.flow.variable.saveButton")}
              </Button>
            </div>
          </div>
        </>
      }
    >
      {nodeSummary({ type: "variable", data: { variableName, variableValue } })}
    </AerosNode>
  );
});

export default VariableNode;

export const getFlowVariable = (name) => {
  if (!window.flowVariables) {
    return undefined;
  }
  return window.flowVariables[name];
};

export const setFlowVariable = (name, value) => {
  if (!window.flowVariables) {
    window.flowVariables = {};
  }
  window.flowVariables[name] = value;
  const event = new CustomEvent("flowVariableUpdate", {
    detail: { name, value },
  });
  window.dispatchEvent(event);
  return value;
};
